import axios from 'axios';
import { isLoggedIn, Logout, readRefreshToken, readToken, storeToken } from './localStorage.services';
import { message } from 'antd';
import { baseUrl } from 'src/utils/main';
// import { Navigate, useNavigate } from 'react-router-dom';

axios.defaults.baseURL = `${baseUrl}/api/`;
const NoAccessTokenURL = ['user/login/'];
// const navigate = useNavigate();

const handleAlerts = (error) => {
  if (error.response) {
    const status = error.response.status;
    if (status === 401) {
    } else if (status === 500) {
      message.error('Sorry, Internal server error.').then(() => {
        window.history.back();
      });
    } else {
      if (error.response.data.errors) {
        if (error.response.data.errors.email) {
          message.error(`${error.response.data.errors.email}`);
        } else if (error.response.data.errors.non_field_errors) {
          message.error(`${error.response.data.errors.non_field_errors}`);
        } else {
          if (typeof error.response.data.errors === 'object') {
            message.error(`${JSON.stringify(error.response.data.errors, null, 2)}`);
          } else {
            message.error(`${error.response.data.errors || error.response.data.errors.message}`);
          }
        }
      }
    }
  } else {
    message.error('An error occurred');
  }
};

const handleSuccess = (response) => {
  if (response.status === 200) {
    if (response.data.message) {
      message.success(response.data.message);
    }
  } else if (response.status === 201) {
    if (response.data.message) {
      message.success(response.data.message);
    }
  }
};

let isRefreshing = false;

const refreshAccessToken = async () => {
  isRefreshing = true;
  try {
    let newAccessToken;
    if (isLoggedIn) {
      const response = await axios
        .post('user/token/refresh/', {
          refresh: readRefreshToken(),
        })
        .catch((err) => (window.location.href = '/login'));
      console.log('newAccessToken', response);
      newAccessToken = response.access;
      storeToken(newAccessToken);
    } else {
      window.location.href = '/login';
    }
    isRefreshing = false;
    return newAccessToken;
  } catch (error) {
    isRefreshing = false;
    console.error('Error refreshing access token:', error);
    throw error;
  }
};

axios.interceptors.request.use(
  (config) => {
    const accessToken = readToken();
    let AccessTokenNeeded = true;
    NoAccessTokenURL.map((data) => {
      if (config.url === data) {
        AccessTokenNeeded = false;
      }
    });
    if (config.url.includes('user/reset-password/')) {
      AccessTokenNeeded = false;
    }
    if (accessToken && AccessTokenNeeded) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    handleSuccess(response);
    return response.data;
  },
  async (error) => {
    handleAlerts(error);
    if (error.response) {
      const status = error.response.status;
      const originalRequest = error.config;

      if (status === 401 && isRefreshing !== true) {
        try {
          const newAccessToken = await refreshAccessToken();
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axios(originalRequest); // Retry the original request with the new token
        } catch (refreshError) {
          // Handle refresh token error (e.g., redirect to login page)
          console.error('Error refreshing access token:', refreshError);
        }
      } else if (error.response.data.errors.auto_logout) {
        // console.error("Request Error:", error.request);
        setTimeout(Logout, 1500);
      }
    } else {
      // console.error("Error Message:", error.message);
    }

    return Promise.reject(error);
  }
);

export default axios;
